import { apiQuery } from '../';

export const recruitersApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getRecruiters: builder.query({
        transformResponse: (response) => response.data,
        query: () => {
          return {
            method: 'get',
            url: '/users/recruiters',
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const { useGetRecruitersQuery } = recruitersApi;
